import FactManagementPage from "@/features/facts/components/FactManagementPage";

export default function GutWellnessFactsPage() {
  return (
    <FactManagementPage
      section="gut-wellness"
      type="gut"
      title="Gut and Wellness Facts Management"
      description="Manage all the guts and wellness facts in one place."
    />
  );
}
